// extracted by mini-css-extract-plugin
module.exports = {"container":"form-success-module--container--3VC-p","heading":"form-success-module--heading--ulk3q"};